module.exports = __webpack_public_path__ + "static/assets/a68a1e36495eb621340a2da84a199019.svg";